var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainNavigation'),_c('ConfirmationModal'),_c('CreateFolderModal'),_c('UploadFilesModal'),_c('UploadVideosModal'),_c('FilePreviewModal'),_c('UploadUrlModal'),_c('FilePickerModal'),_c('ChangeFileModal'),_c('DevicePickerModal'),_c('PlaylistPickerModal'),_c('PlaylistUsageModal'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }